import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, FormControl, InputLabel, Select, MenuItem,
    InputAdornment, Backdrop, CircularProgress, Button, FormControlLabel, Checkbox, Alert
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import BookmarkIcon from '@mui/icons-material/Bookmark';

import { get_suppliers } from '../../../../services/for_allServices';
import Set_simple_contract from '../set_simple_contract/Set_simple_contract';
import { get_directions_and_responsible, get_contract_values_lists } from '../../../../services/purchase_service';


const Add_Contract = ({ open, handleClose, purchase_service }) => {
    const [suppliers, setSuppliers] = useState([]);
    const [id_submission, setId_submission] = useState('');
    const [setContract, setSetContract] = useState(false);

    const [supplier, setSupplier] = useState('');
    const [waiting, setWaiting] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [warningText, setWarningText] = useState('');

    const [contractSubject, setContractSubject] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [durationYears, setDurationYears] = useState('');
    const [isRenewable, setIsRenewable] = useState(false);
    // const [financialTerms, setFinancialTerms] = useState('');
    // const [billingTerms, setBillingTerms] = useState('');
    // const [paymentTerms, setPaymentTerms] = useState('');
    const [penalties, setPenalties] = useState('');
    const [terminationConditions, setTerminationConditions] = useState('');
    const [deliverables, setDeliverables] = useState([]);
    const [applicableLaw, setApplicableLaw] = useState('');
    const [contract_details, setContract_details] = useState(null);
    const [directors, setDirectors] = useState([]);
    const [directions, setDirections] = useState([]);
    const [director, setDirector] = useState('');
    const [direction, setDirection] = useState('');

    const [valuesLists, setValuesLists] = useState({
        financial_terms: [],
        billing_terms: [],
        payment_terms: [],
    });

    const [financialTerms, setFinancialTerms] = useState(''); //  store ID
    const [billingTerms, setBillingTerms] = useState('');
    const [paymentTerms, setPaymentTerms] = useState('');


    useEffect(() => {
        const loadData = async () => {
            try {
                const response = await get_suppliers();
                console.log("load_data: ", response.data);
                setSuppliers(response.data);


                get_directions_and_responsible().then((res) => {
                    // console.log("Directions and directors: ", res.data);
                    setDirectors(res.data.directors || []);
                    setDirections(res.data.directions || []);
                }).catch((err) => {
                    console.error("Error fetching directions and departments: ", err);
                })

                get_contract_values_lists().then((res) => {
                    console.log("values: ", res.data);
                    setValuesLists(res.data);

                }).catch((err) => {
                    console.error("Error fetching directions and departments: ", err);
                })

            } catch (error) {
                console.log(error.response);
            }

        };
        loadData();
    }, []);

    const addContract = () => {
        const contractData = {
            reference: id_submission,
            supplier_id: supplier,
            subject: contractSubject,
            start_date: startDate,
            end_date: endDate,
            duration_years: parseInt(durationYears),
            renewable: isRenewable,
            financial_terms: financialTerms,
            billing_terms: billingTerms,
            payment_terms: paymentTerms,
            late_penalties: penalties,
            termination_conditions: terminationConditions,
            deliverables: deliverables,
            applicable_law: applicableLaw,
            director: director,
            direction: direction,
        };
        setContract_details(contractData);
        console.log("Contract Data to Submit:", contractData);
        // Submit to backend API here
    };




    function openContractView() {

        if (!id_submission || !supplier || !contractSubject || !startDate || !endDate || !durationYears || !financialTerms || !billingTerms || !paymentTerms || !applicableLaw) {
            setErrorText("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        addContract();


        setWarningText('');
        setSetContract(true);
    }
    function handleCloseSetContrat() {
        setSetContract(false);
        setId_submission(null);
    }
    const handleDirectionChange = (e) => {
        const selected_direction_id = e.target.value;
        setDirection(selected_direction_id);

        const direction_object = directions.find(dir => dir.id === selected_direction_id);
        if (direction_object && direction_object.director) {
            setDirector(direction_object.director);
        }
    }


    return (
        <>
            <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
                <DialogTitle sx={{
                    backgroundColor: '#f8f4f4',
                    color: '#000',
                    padding: '16px 24px',
                    fontSize: '1.25rem',
                    fontWeight: 500
                }}>
                    Ajouter votre contrat
                </DialogTitle>

                <DialogContent sx={{ padding: '20px 24px' }}>
                    <div className="add_product_modal_infos">
                        <div className="inputs_container" style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                            gap: '20px',
                            alignItems: 'start'
                        }}>
                            <TextField
                                variant="outlined"
                                label="Référence de contrat"
                                className="input_form"
                                fullWidth
                                size="small"
                                value={id_submission}
                                onChange={(e) => setId_submission(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <BookmarkIcon color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <FormControl variant="outlined" className="input_form" fullWidth size="small">
                                <InputLabel>Maison mère -- Fournisseur</InputLabel>
                                <Select
                                    value={supplier}
                                    onChange={(e) => setSupplier(e.target.value)}
                                    label="Maison mère -- Fournisseur"
                                >
                                    {suppliers.map((val, index) => (
                                        <MenuItem key={"supplier-" + index} value={val.id}>
                                            {val.parentCompany + " -- " + val.fullName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>


                            <FormControl variant="outlined" className="input_form" fullWidth size="small">
                                <InputLabel>Direction</InputLabel>
                                <Select
                                    value={direction}
                                    onChange={handleDirectionChange}
                                    label="Direction"
                                >
                                    {directions.map((val, index) => (
                                        <MenuItem key={"Direction-" + index} value={val.id}>
                                            {val.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" className="input_form" fullWidth size="small">
                                <InputLabel>Responsable</InputLabel>
                                <Select
                                    value={director}
                                    onChange={(e) => setDirector(e.target.value)}
                                    label="Departement"
                                >
                                    {directors.map((val, index) => (
                                        <MenuItem key={"Responsable-" + index} value={val.id}>
                                            {val.fullName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>


                            <TextField
                                variant="outlined"
                                label="Objet du contrat"
                                className="input_form"
                                fullWidth
                                size="small"
                                value={contractSubject}
                                onChange={(e) => setContractSubject(e.target.value)}
                            />

                            <TextField
                                variant="outlined"
                                label="Date de début"
                                type="date"
                                className="input_form"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />

                            <TextField
                                variant="outlined"
                                label="Date de fin"
                                type="date"
                                className="input_form"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />

                            <TextField
                                variant="outlined"
                                label="Durée (ans)"
                                type="number"
                                className="input_form"
                                fullWidth
                                size="small"
                                value={durationYears}
                                onChange={(e) => setDurationYears(e.target.value)}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isRenewable}
                                        onChange={(e) => setIsRenewable(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="Renouvelable"
                                sx={{ marginLeft: '8px' }}
                            />

                            <FormControl variant="outlined" className="input_form" fullWidth size="small">
                                <InputLabel>Conditions financières</InputLabel>
                                <Select
                                    value={financialTerms}
                                    onChange={(e) => setFinancialTerms(e.target.value)}
                                    label="Conditions financières"
                                >
                                    {valuesLists.financial_terms?.map((item) => (
                                        <MenuItem key={item.code} value={item.code}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>


                            <FormControl variant="outlined" className="input_form" fullWidth size="small">
                                <InputLabel>Conditions de facturation</InputLabel>
                                <Select
                                    value={billingTerms}
                                    onChange={(e) => setBillingTerms(e.target.value)}
                                    label="Conditions de facturation"
                                >
                                    {valuesLists.billing_terms?.map((item) => (
                                        <MenuItem key={item.code} value={item.code}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>


                            <FormControl variant="outlined" className="input_form" fullWidth size="small">
                                <InputLabel>Conditions de paiement</InputLabel>
                                <Select
                                    value={paymentTerms}
                                    onChange={(e) => setPaymentTerms(e.target.value)}
                                    label="Conditions de paiement"
                                >
                                    {valuesLists.payment_terms?.map((item) => (
                                        <MenuItem key={item.code} value={item.code}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>


                            <TextField
                                variant="outlined"
                                label="Pénalités de retard"
                                className="input_form"
                                fullWidth
                                size="small"
                                value={penalties}
                                onChange={(e) => setPenalties(e.target.value)}
                                multiline
                                rows={3}
                            />

                            <TextField
                                variant="outlined"
                                label="Conditions de résiliation"
                                className="input_form"
                                fullWidth
                                size="small"
                                value={terminationConditions}
                                onChange={(e) => setTerminationConditions(e.target.value)}
                                multiline
                                rows={3}
                            />

                            <FormControl variant="outlined" className="input_form" fullWidth size="small">
                                <InputLabel>Livrables</InputLabel>
                                <Select
                                    multiple
                                    value={deliverables}
                                    onChange={(e) => setDeliverables(e.target.value)}
                                    label="Livrables"
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    <MenuItem value="Rapport final">Rapport final</MenuItem>
                                    <MenuItem value="Code source">Code source</MenuItem>
                                    <MenuItem value="Documentation">Documentation</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl variant="outlined" className="input_form" fullWidth size="small">
                                <InputLabel>Droit applicable</InputLabel>
                                <Select
                                    value={applicableLaw}
                                    onChange={(e) => setApplicableLaw(e.target.value)}
                                    label="Droit applicable"
                                >
                                    <MenuItem value="Marocain">Marocain</MenuItem>
                                    <MenuItem value="Français">Français</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions sx={{
                    padding: '16px 24px',
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        {errorText && (
                            <Alert severity="error" sx={{ marginRight: 2 }}>
                                {errorText}
                            </Alert>
                        )}
                        {warningText && (
                            <Alert severity="warning" sx={{ marginRight: 2 }}>
                                {warningText}
                            </Alert>
                        )}
                    </div>

                    <div style={{ display: 'flex', gap: '8px' }}>
                        <Button
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                color: '#fff',
                                backgroundColor: "#f02c44",
                            }}
                            startIcon={<CancelIcon />}
                            onClick={handleClose}
                        >
                            Annuler
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                backgroundColor: '#20bc74', // Black background
                                color: '#fff', // White text
                            }}
                            startIcon={<AddIcon />}
                            onClick={() => {
                                const isValid = openContractView();
                                if (isValid) {
                                    addContract();
                                    handleClose();
                                }
                            }}
                        >
                            Ajouter
                        </Button>
                    </div>
                </DialogActions>



                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={waiting}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Dialog>
            {id_submission != null && setContract == true && (
                <Set_simple_contract
                    setContract={setContract}
                    handleCloseSetContrat={() => handleCloseSetContrat(id_submission)}
                    purchase_service={purchase_service}
                    chosenSubmission={id_submission}
                    id_supplier={supplier}
                    contract_details={contract_details}
                    setContract_details={setContract_details}
                />
            )}
        </>
    );
};

export default Add_Contract;
